import { t as localeText } from "@/i18n/translate";
import { useTranslation as useLocaleSubscription } from "react-i18next";
import { useState } from "react";
import { Button, Checkbox, Dialog } from "@/shared/ui";
import type { V2Asset } from "../types";

export function EditorImageRightsDialog({ assets, onClose, onConfirm }: {
  assets: readonly V2Asset[];
  onClose: () => void;
  onConfirm: (assets: readonly V2Asset[]) => Promise<void>;
}) {
  useLocaleSubscription();
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const plural = assets.length > 1;
  async function submit() {
    if (!confirmed || busy) return;
    setBusy(true); setError("");
    try { await onConfirm(assets); onClose(); }
    catch (failure) { setError(failure instanceof Error ? failure.message : localeText("interface.permission_couldn_t_be_saved_try_again_448dae2a", { defaultValue: "Permission couldn’t be saved. Try again." })); }
    finally { setBusy(false); }
  }
  return <Dialog open title={plural ? localeText("interface.confirm_you_can_use_these_images_43651fd8", { defaultValue: "Confirm you can use these images" }) : localeText("interface.confirm_you_can_use_this_image_a9b09dd8", { defaultValue: "Confirm you can use this image" })} onClose={onClose} dismissible={!busy} footer={<><Button variant="ghost" disabled={busy} onClick={onClose}>{localeText("interface.cancel_77dfd213", { defaultValue: "Cancel" })}</Button><Button variant="accent" disabled={!confirmed || busy} loading={busy} onClick={() => void submit()}>{localeText("interface.continue_2e026239", { defaultValue: "Continue" })}</Button></>}>
    <div className="grid gap-4">
      <div className="flex flex-wrap gap-2">{assets.map(asset => <div key={asset.id} className="flex min-w-0 items-center gap-2 text-sm">{asset.thumbnail_url || asset.url ? <img src={asset.thumbnail_url ?? asset.url} alt="" className="size-12 rounded-lg object-cover" /> : null}<span className="truncate">{asset.name}</span></div>)}</div>
      <Checkbox label={plural ? localeText("interface.i_own_these_images_or_have_permission_to_use_the_2947e072", { defaultValue: "I own these images or have permission to use them" }) : localeText("interface.i_own_this_image_or_have_permission_to_use_it_436130f1", { defaultValue: "I own this image or have permission to use it" })} checked={confirmed} disabled={busy} onChange={event => setConfirmed(event.target.checked)} />
      {error && <p role="alert" className="text-sm text-danger">{error}</p>}
    </div>
  </Dialog>;
}
